import { CalendarLegend } from './CalendarLegend'
import { CalendarLegendEntry } from './CalendarLegendEntry'

export { CalendarLegend, CalendarLegendEntry }
